module.exports = __webpack_public_path__ + "img/PL08774.2bc68c24.png";